'use es6';

// this function has been moved to reporting-data:
import getErrorTypeFromException from 'reporting-data/lib/getErrorTypeFromException';
export const get = getErrorTypeFromException;